import { get, put } from '../request';

export function getSettings() {
    return get('/api/v2/company-analytics/settings');
}

export function updateSettings(settings) {
    return put('/api/v2/company-analytics/settings', {
        postData: settings,
    });
}
